import styles from "./CountLabelShowMore.module.scss"

export const Counter = ({
  count,
  label
}: {
  count: number | string
  label?: string
}) => <span className={styles.count}>{label ? label : `+${count}`}</span>
